import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useFormikContext } from "formik";

const containerStyle = {
  width: "100%",
  height: "300px"
};

const defaultCenter = {
  lat: 12.9716,
  lng: 77.5946
};

const MapPicker = () => {
  const { values, setFieldValue } = useFormikContext();

  const handleClick = (e) => {
    if (e.latLng) {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setFieldValue("latitude", lat);
      setFieldValue("longitude", lng);
    }
  };

  return (
    <LoadScript googleMapsApiKey={'AIzaSyDURu1GQkz8XhML9KTW8N_NRVQvIh4pIsU'}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={
          values.latitude && values.longitude
            ? { lat: Number(values.latitude), lng: Number(values.longitude) }
            : defaultCenter
        }
        zoom={13}
        onClick={handleClick}
      >
        {values.latitude && values.longitude && (
          <Marker position={{ lat: Number(values.latitude), lng: Number(values.longitude) }} />
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapPicker;
